export default function PrimaryButton({ children, ...props }) {
    return (
      <button
        {...props}
        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      >
        {children}
      </button>
    );
  }
  